
<div>
  <detail-view-file-property-table
    :attachments="attachments()"
  >
  </detail-view-file-property-table>

  <div class="cta" v-if="hasMore">
    <a :href="detailViewAttachmentsLink" type="button" class="btn grey-to-blue inline">View All</a>
  </div>
</div>
